<template>
  <div class="header">
    <a-form
      ref="formRef"
      class="form"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <a-flex wrap="wrap" gap="small" align="flex-end">
        <EntityPicker
          v-model:value="formState.entity"
          default-behavior
          :show-all="false"
          label="Empresa"
          required
        />
        <CampaignPicker
          v-model:value="formState.portfolio"
          default-behavior
          :show-all="false"
          :entity="formState.entity"
          label="Campaña"
          required
          :enable-calls-ringing="[ReportTypes.CallAttempts, ReportTypes.Callback].includes(typeReport)"
        />
        <a-form-item name="date" required>
          <template #label>
            {{ ReportTypes.Callback != typeReport? "Rango de fecha" : "Fecha de inicio"}}
            <a-tooltip title="Solo se permite un rango de 31 días como máximo." v-if="ReportTypes.Callback != typeReport">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </template>
          <plan-range-picker
            v-if="ReportTypes.Callback != typeReport"
            v-model="formState.date"
            :default-limit="DateRangeLimit"
          />
          <a-date-picker
            v-else
            v-model:value="formState.date"
            format="DD/MM/YYYY"
            valueFormat="YYYY-MM-DD"
          />
          
        </a-form-item>
        <a-form-item name="time" required v-if="ReportTypes.Callback == typeReport" label="Rango de Hora">
          <a-range-picker
            v-model:value="formState.time"
            :disabled-date="disabledDate"
            @openChange="onOpenChange"
            @calendarChange="onCalendarChange"
            picker="time"
          />
        </a-form-item>
      </a-flex>
      <div class="back">
        <div class="download">
          <span class="total" v-if="countReport > -1 && typeReport != ReportTypes.CallAttempts">{{ countReport }} Registros</span>

          <a-tooltip :title="isGlobalDownloading ?
            'Tiene una descarga pendiente' :
            isDisabled ?
            'Completa los filtros requeridos para descargar el reporte.' : 
            'Se descargarán únicamente los datos de la tabla de acuerdo a los filtros seleccionados.'"
          >
            <a-button
              :type="[ReportTypes.CallsAnswered, ReportTypes.IncomingPerAgent].includes(typeReport) ? 'link' : 'primary'"
              :disabled="isDisabled || isGlobalDownloading"
              :loading="isLoading"
              @click="handleDownload"
              class="button__download"
            >
              Descargar
              <DownloadOutlined />
            </a-button>
          </a-tooltip>
        </div>
        <a-tooltip placement="topLeft">
          <template #title v-if="isDisabled">
            <span> {{ isDisabled ? "Completa los filtros requeridos para iniciar tu búsqueda." : null }}</span>
          </template>
          <a-button type="primary" :disabled="isDisabled || loadingSearch" :loading="loadingSearch" @click="handleSearch" 
            v-if="[ReportTypes.CallsAnswered, ReportTypes.IncomingPerAgent].includes(typeReport) ">
            Buscar
            <SearchOutlined />
          </a-button>
        </a-tooltip>
      </div>
    </a-form>
  </div>
  <!-- {{ columnsTotal }} -->
  <div v-if="(ReportTypes.CallsAnswered == typeReport && dataSource?.length > 0) || ReportTypes.IncomingPerAgent == typeReport">
    <a-table
      class="table_synlab"
      size="middle"
      :columns="columnsTable"
      :data-source="dataSource"
      :scroll="scrollStyle"
      :pagination="false"
      v-if="dataSource?.length > 0 || typeReport == ReportTypes.IncomingPerAgent"
    >
      <template #headerCell="{ column }">
        <template v-if="column.key === 'total' && typeReport == ReportTypes.CallsAnswered">
          <span>
            Total
            <a-tooltip title="Llamadas cuyo estado final es atendida/contestada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </span>
        </template>
        <template v-else-if="column.key === 'answered' && typeReport == ReportTypes.IncomingPerAgent">
          <span>
            Telefonía atendidas
            <a-tooltip title="Llamadas entrantes vía telefonía cuyo estado final es atendida/contestada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </span>
        </template>
        <template v-else-if="column.key === 'not_answered' && typeReport == ReportTypes.IncomingPerAgent">
          <span>
            Telefonía no atendidas
            <a-tooltip title="Llamadas entrantes vía telefonía cuyo estado final es no atendida/no contestada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </span>
        </template>
        <template v-else-if="column.key === 'answered_whatsapp_voice' && typeReport == ReportTypes.IncomingPerAgent">
          <span>
            WhatsApp Voice atendidas
            <a-tooltip title="Llamadas entrantes vía WhatsApp Voice cuyo estado final es atendida/contestada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </span>
        </template>
        <template v-else-if="column.key === 'not_answered_whatsapp_voice' && typeReport == ReportTypes.IncomingPerAgent">
          <span>
            WhatsApp Voice no atendidas
            <a-tooltip title="Llamadas entrantes vía WhatsApp Voice cuyo estado final es no atendida/no contestada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </span>
        </template>
      </template>
      <template #user_full_name="{ text }">
        <span v-if="text?.trim().length > 0">{{ text }}</span>
        <span v-else>
          Sin Usuario
          <a-tooltip title="Se indica para las llamadas no atendidas donde no se logró asignar a un usuario.">
            <InfoCircleOutlined style="margin-left: 5px" />
          </a-tooltip>
        </span>
      </template>
      <template #summary>
        <a-table-summary fixed>
          <a-table-summary-row>
            <a-table-summary-cell :index="0">Total</a-table-summary-cell>
            <a-table-summary-cell v-for="(column, key) in columnsTotal" :key="key" :index="key + 1">
              {{ getSummaryValue(column) }}
            </a-table-summary-cell>
          </a-table-summary-row>
        </a-table-summary>
      </template>
    </a-table>
  </div>
  <section v-else class="info">
    Este reporte solo se podrá descargar al
    <br />
    aplicar los filtros
  </section>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, ref, toRaw, watch } from "vue";
import { useStore } from "vuex";
import { DownloadOutlined, InfoCircleOutlined, SearchOutlined } from "@ant-design/icons-vue";
import { Dayjs } from "dayjs";
import { downloadCommonReport } from "@/app/reports/services";
import { columns, columnsCallsAnswered, columnsIncomingPerAgent } from "@/app/reports/utils/constants";
import { columnsReportSeven } from "@/app/reports/utils/constants";
import { PdpTypeLabel, ReportTypes } from "@/app/reports/utils/enums";
import BasesPicker from "@/app/shared/components/pickers/BasesPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import SelectorUsers from "@/app/shared/components/selectors/SelectorUsers.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";
import { ChannelType } from "@/app/shared/utils/enums";
import { fetchAllQueues } from "@/app/queues/services";

import PlanRangePicker from "@/app/shared/components/pickers/PlanRangePicker.vue";

// Define RangeValue inline or in a TypeScript file if needed
// const RangeValue = [Dayjs, Dayjs];

export default defineComponent({
  components: {
    EntityPicker,
    CampaignPicker,
    BasesPicker,
    DownloadOutlined,
    SearchOutlined,
    SelectorUsers,
    InfoCircleOutlined,
    PlanRangePicker,
  },
  props: {
    typeReport: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const endOpen = ref(false);
    const showPagination = ref(false);
    const isLoading = ref(false);
    const loadingSearch = ref(false);
    const formRef = ref();
    const hasWhatsappVoiceChannel = ref(true);
    const formState = reactive({
      entity: undefined,
      portfolio: undefined,
      date: null,
      time: null,
    });
    const rules = {
      entity: [{ required: true, message: "Campo requerido" }],
      portfolio: [{ required: true, message: "Campo requerido" }],
      date: [{ required: ReportTypes.Callback != props.typeReport, message: "Campo requerido" }],
      time: [
        {
          required: ReportTypes.Callback == props.typeReport,
          message: "Campo requerido",
        },
      ],
    };
    const DateRangeLimit = 30;
    const { handleCalendarChange, disabledDateRage } = useDateRangeLimit(DateRangeLimit);
    const { scrollStyle } = useScrollResize({ headerMargin: 470 });
    const { isGlobalDownloading } = useGlobalDownloadState();
    
    const dates = ref();
    // const scrollStyle = ref({ x: 2000, y: 500 });

    // const onResize = () => {
    //   scrollStyle.value = { x: 1800, y: window.innerHeight - 470 };
    // };

    // onBeforeUnmount(() => {
    //   window.removeEventListener("resize", onResize);
    // });

    onMounted(() => {
      formRef.value?.resetFields();
      store.commit("SET_REPORT_CALLS_ANSWERED", []);
      store.commit("SET_REPORT_CALLS_INCOMING", []);
      showPagination.value = false;

      // table resize
      // window.addEventListener("resize", onResize);
      // scrollStyle.value = { x: 1800, y: window.innerHeight - 470 };
    });

    const isDisabled = computed(() => {
      const hasValidDateRange = ReportTypes.Callback != props.typeReport ? formState.date?.[0] && formState.date?.[1] : formState.time?.[0] && formState.time?.[1] && formState.date;

      console.log(hasValidDateRange, 'hasValidDateRange');
      console.log(formState, 'formState');
      console.log(!(
        hasValidDateRange &&
        formState.portfolio &&
        formState.entity
      ), 'validation');
      return !(
        hasValidDateRange &&
        formState.portfolio &&
        formState.entity
      );
    });
    // columnsFixedTableLeft(columns)
    const report = computed(() => 
      props.typeReport == ReportTypes.CallsAnswered ? 
        store.getters["getReportCallsAnswered"] : store.getters["getReportCallsIncoming"]
    );
    const dataSource = computed(() => report.value?.data);

    const columnsTotal = computed(() => {
      if (props.typeReport == ReportTypes.CallsAnswered) {
        const columns = [];
        if (report.value?.totals)
          Object.keys(report.value?.totals).forEach(key => {
            columns.push(key);
          });
        return columns.sort((a, b) => (a === "total" ? -1 : b === "total" ? 1 : 0));
      } else
        return ['total', 'answered', 'not_answered', 'answered_whatsapp_voice', 'not_answered_whatsapp_voice'];
    });

    const columnsTotalAnswered = computed(() => {
      const columns = [];
      if (props.typeReport == ReportTypes.CallsAnswered && report.value?.totals)
        Object.keys(report.value?.totals).forEach(key => {
          if (key == "total") return;
          columns.push(key);
        });
      return columns;
    });

    const countReport = computed(() => dataSource.value?.length);

    const whatsappVoiceHidden = computed(() =>
      !hasWhatsappVoiceChannel.value && 
      report.value?.totals?.['answered_whatsapp_voice'] === 0 && 
      report.value?.totals?.['not_answered_whatsapp_voice'] === 0
    );
    console.log("whatsappVoiceHidden", whatsappVoiceHidden.value)
    const columnsTable = computed(() => {
      const cols = [];
      switch (props.typeReport) {
        case ReportTypes.CallsAnswered:
          cols.push(...columnsCallsAnswered);
          columnsTotalAnswered.value.forEach(value => {
            cols.push({
              title: value,
              dataIndex: value,
              key: value,
              width: 150,
              customCell: (record) => {
                const textCell = record[value];
                return {
                  class: textCell ? '' : 'cell-none',
                };
              },
              customRender: ({ text }) => {
                return text;
              }
            });
          });
          return cols;
        case ReportTypes.IncomingPerAgent:
          columnsIncomingPerAgent.forEach(col => {
            if (col.key === 'answered_whatsapp_voice' || col.key === 'not_answered_whatsapp_voice') {
              cols.push({
                ...col,
                customCell: () => ({ class: whatsappVoiceHidden.value ? 'cell-none' : '' }),
                customRender: ({ text }) => (whatsappVoiceHidden.value ? '' : text),
              });
            } else {
              cols.push({ ...col });
            }
          });
          return cols;
        default:
          return columns;
      }
    });

    const checkWhatsappVoiceChannel = async (portfolioId) => {
      try {
        const data = await fetchAllQueues("", portfolioId);
        const queues = data?.results || [];
        console.log("channels by queue", queues)
        const hasVoice = queues.some((q) =>
          Array.isArray(q?.channels_customer) &&
          q.channels_customer.some((cc) => cc?.channel?.id === ChannelType.WhatsappVoice)
        );
        hasWhatsappVoiceChannel.value = hasVoice;
      } catch (e) {
        console.error('Error fetching queues to detect WhatsApp Voice', e);
        hasWhatsappVoiceChannel.value = false;
      }
    };

    onMounted(() => {
      if (formState.portfolio) checkWhatsappVoiceChannel(formState.portfolio);
    });

    watch(
      () => formState.portfolio,
      (newVal) => {
        if (newVal) checkWhatsappVoiceChannel(newVal);
      }
    );

    const getSummaryValue = (columnKey) => {
      if (whatsappVoiceHidden.value && (columnKey === 'answered_whatsapp_voice' || columnKey === 'not_answered_whatsapp_voice'))
        return '';
      return report.value?.totals?.[columnKey];
    };

    const formatDateTime = (date, time) => {
      const [datePart] = date.split("T");
      console.log(time.format("HH:mm:ss"), 'time');
      const timePart = time.format("HH:mm:ss");
      
      return `${datePart} ${timePart}`;
    };

    const handleDownload = async () => {
      try {
        isLoading.value = true;
        
        await downloadCommonReport({
          entity: toRaw(formState).entity,
          campaign: toRaw(formState).portfolio,
          startValue: ReportTypes.Callback != props.typeReport 
            ? formState.date?.[0] 
            : formatDateTime(formState.date, formState.time?.[0]),
          endValue: ReportTypes.Callback != props.typeReport 
            ? formState.date?.[1] 
            : formatDateTime(formState.date, formState.time?.[1]),
          type: props.typeReport,
        });
        isLoading.value = false;
      } catch (error) {
        console.log("Error", error);
        isLoading.value = false;
      }
    };

    const handleSearch = async () => {
      if (loadingSearch.value) return;

      const action = props.typeReport == ReportTypes.CallsAnswered ? 'fetchAllCallsAnswered' : 'fetchAllIncomingPerAgent';

      try {
        loadingSearch.value = true;

        await store.dispatch(action, {
          query: {
            entity: toRaw(formState).entity,
            portfolio: toRaw(formState).portfolio,
            startValue: formState.date?.[0],
            endValue: formState.date?.[1],
            type: props.typeReport,
          },
          pagination: {},
        });
        // showPagination.value = true;
      } catch (error) {
        console.log("Error", error);
      } finally {
        loadingSearch.value = false;
      }
    };

    // const handleTableChange = async (pagination) => {
    //   await store.dispatch("fetchAllCallsAnswered", {
    //     query: {
    //       entity: toRaw(formState).entity,
    //       campaign: toRaw(formState).campaign,
    //       base: toRaw(formState).base,
    //       startValue: formState.startDate.format("YYYY-MM-DD"),
    //       endValue: formState.endDate.format("YYYY-MM-DD"),
    //       user: toRaw(formState).user,
    //       type: props.typeReport,
    //     },
    //     pagination: pagination,
    //   });
    // };

    const disabledDate = (current) => {
      if (!dates.value || dates.value.length === 0) {
        return false;
      }
      const tooLate = dates.value[0] && current.diff(dates.value[0], "days") > 7;
      const tooEarly = dates.value[1] && dates.value[1].diff(current, "days") > 7;
      return tooEarly || tooLate;
    };

    const onOpenChange = (open) => {
      if (open) {
        dates.value = [];
      }
    };

    const onCalendarChange = (val) => {
      dates.value = val;
    };

    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        formState.entity.value = 1;
      }
    });

    return {
      onCalendarChange,
      onOpenChange,
      disabledDate,
      dateTimeToSlashFormat,
      scrollStyle,
      formRef,
      formState,
      rules,
      user,
      endOpen,
      isDisabled,
      countReport,
      handleDownload,
      handleSearch,
      columnsTable,
      handleCalendarChange,
      disabledDateRage,
      // handleTableChange,
      report,
      showPagination,
      isLoading,
      loadingSearch,
      isGlobalDownloading,
      PdpTypeLabel,
      ReportTypes,
      dataSource,
      columnsTotal,
      hasWhatsappVoiceChannel,
      getSummaryValue,
      DateRangeLimit,
    };
  },
  computed: {
    isHideBase() {
      return !this.user?.customer?.enable_bases;
    },
  },
});
</script>

<style lang="sass" scoped>
.form
  display: flex
  gap: 8px
  justify-content: space-between
  width: 100%
.selectors
  display: grid
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 220px
  gap: 15px
  padding: 15px 5px 5px
:deep(.ant-calendar-picker-icon)
  top: 50% !important
:deep(.ant-calendar-picker)
  width: 100%
.back
  margin-top: 30px
  text-align: right
  margin-bottom: 10px
  display: flex
.main-text
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: 28px
  letter-spacing: 0em
  text-align: center
  color: $gray-7
.total
  margin-top: 3%
  color: $gray-8

// .download
//   margin-top: 16px

// .button__download
//   padding: 0 0 0 16px

.hideBase
  display: nome !important

.flex
  display: flex
  margin-top: 30px
  position: absolute
  justify-self: flex-end
  align-items: center

.buttonDownload
  margin: 0
  padding-right: 10px

.totalReport
  color: $gray-8

.date__start
  width: 170px

.date__end
  width: 160px

.header
  margin-top: 12px

.info
  display: grid
  place-content: center
  text-align: center
  color: $gray-7
  font-size: 20px
  font-weight: 400
  margin-top: 150px

.totalReport
  color: red

::v-deep(td.ant-table-cell.cell-none)
  background-color: rgb(245 245 245) !important

::v-deep(.table_synlab tfoot th),
::v-deep(.table_synlab tfoot td)
  background: rgb(245 245 245)
  font-weight: 600
  font-size: 14px
  line-height: 22px
</style>
